import { Pipeline } from '../../ecg/types/ecg.type';
import { Diagnostic } from '../types/diagnostic';

export const getPipeline = (diagnostics: Diagnostic[]): Pipeline => {
  return diagnostics[0]?.pipeline ?? 'resting';
};
